var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8211_9485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3437 13.875L23.75 13.2812L18.25 18.7813C17.5625 19.4688 16.4063 19.4688 15.7188 18.7813L10.2188 13.3125L9.625 13.9062L13.7188 18L9.625 22.0937L10.2188 22.6875L14.3125 18.5938L15.125 19.4063C15.625 19.9063 16.2812 20.1875 16.9688 20.1875C17.6563 20.1875 18.3125 19.9063 18.8125 19.4063L19.625 18.5938L23.7187 22.6875L24.3125 22.0937L20.2188 18L24.3437 13.875Z",
    fill: "#F55943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9886 25.5H9.01135C8.08103 25.5 7.3125 24.7213 7.3125 23.7787V12.2213C7.3125 11.2787 8.08103 10.5 9.01135 10.5H24.9886C25.919 10.5 26.6875 11.2787 26.6875 12.2213V23.7787C26.6875 24.7213 25.919 25.5 24.9886 25.5V25.5ZM8.9709 11.6066C8.64731 11.6066 8.40462 11.8525 8.40462 12.1803V23.7377C8.40462 24.0656 8.64731 24.3115 8.9709 24.3115H24.9482C25.2718 24.3115 25.5145 24.0656 25.5145 23.7377V12.1803C25.5145 11.8525 25.2718 11.6066 24.9482 11.6066H8.9709Z",
    fill: "#F55943"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8211_9485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(7.5 7.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.4a1a02ab53305a858042474c86ebff34.svg";
export { ForwardRef as ReactComponent };